import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { Header } from "../../components/Header";
import { MainButton } from "../../components/MainButton";
import { Menu } from "../../components/Menu";
import { floatToPrice } from "../../functions/price_functions";
import { useOrder } from "../../hooks/useOrder";
import InputMask from "react-input-mask";
import "./index.css";
import { Loading } from "../../components/Loading";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { usePluginspace } from "../../hooks/usePluginspace";
import api from "../../services/api";
import { useToast } from "../../hooks/useToast";

// Importando imagens das bandeiras
import visaLogo from "../../assets/images/visa.svg";
import masterCardLogo from "../../assets/images/masterCard.svg";
import americanExpressLogo from "../../assets/images/americanExpress.svg";
import eloLogo from "../../assets/images/elo.svg";
import hipercardLogo from "../../assets/images/hipercard.svg";
import aleloLogo from "../../assets/images/alelo.svg";
import ticketLogo from "../../assets/images/ticket.svg";
import maestroLogo from "../../assets/images/maestro.svg";
import { usePayment, usePaymentActions } from "../../contexts/paymentContext/paymentContext";
import { useCartFreight, useCartWithDiscount } from "../../contexts/cartContext/cartContext";
import { useDiscount } from "../../contexts/discountContext/discountContext";

type PlansType = {
  id: number;
  codePlan: number;
  installment: number;
};

type IntegrationType = {
  id: number;
  pluginconfigId: number;
  brand: string;
  cardOperator: number;
  codePay: string;
  nameGateway: string;
  paymentPlans: PlansType[];
  typePay: string;
  minimumValueInstallment: number;
  brandItem: any;
};

export function CardPayment() {
  const { getToken, registerAccess, pluginspace } = usePluginspace();
  const { pluginspace_id } = useParams();
  const navigate = useNavigate();

  const toastComponent = useToast();
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [month, setMonth] = useState("1");
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [installments, setInstallments] = useState("1");
  const [brand, setBrand] = useState("");
  const [cvv, setCvv] = useState("");

  const [alarmName, setAlarmName] = useState(false);
  const [alarmNumber, setAlarmNumber] = useState(false);
  const [alarmCvv, setAlarmCvv] = useState(false);

  const { getAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [freight, setFreight] = useState(0);
  const [detectedCodePay, setDetectedCodePay] = useState<string | null>(null);

  const [integrationBrands, setIntegrationBrands] = useState<IntegrationType[]>(
    []
  );
  const [integrationPlans, setIntegrationPlans] = useState<PlansType[]>([]);

  const [hideMenu, setHideMenu] = useState(false);
  const [loggedBrands, setLoggedBrands] = useState<string[]>([]);

  const [maskCard, setMaskCard] = useState("9999 9999 9999 99");
  const [maskCvv, setMaskCvv] = useState("999");
  const [loadingHeader, setLoadingHeader] = useState(true);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [cardBrandImage, setCardBrandImage] = useState<string | null>(null);

  const cartWithDiscount = useCartWithDiscount();
  const {couponDiscount,paymentDiscount} = useDiscount()
  const cartFreight = useCartFreight();
  const payment = usePayment();
  const { setCard, setPaymentMethod, setSelectedInstallment } = usePaymentActions();

  useEffect(() => {
    getConfig();
    registerAccess("card");
  }, []);

  // Função para obter a imagem da bandeira do cartão
  const getCardBrandImage = (brand: string | null) => {
    if (!brand) return null;

    const brandIntegration = integrationBrands.find(
      (integration) => integration.brand.toLocaleLowerCase() === brand
    );

    if (brandIntegration) return brandIntegration.brandItem.img;

    return null;
  };

  async function loadBrandsInstallments() {
    try {
      setLoading(true);

      const resPluginspace = await api.get("/api/pluginspace/this", {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      });
      if (
        resPluginspace.data.data &&
        resPluginspace.data.data[0] &&
        resPluginspace.data.data[0].hash
      ) {
        const resIntegration = await api.post(
          "api/orders/card-payment-get",
          {
            hash: resPluginspace.data.data[0].hash,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        );

        const gatewayId = payment.gatewayId;
        const totalPrice = cartWithDiscount;

        const newBrandsIntegrations: IntegrationType[] =
          resIntegration.data.data.data.filter(
            (integration: IntegrationType) =>
              integration.pluginconfigId === gatewayId &&
              String(integration.brand).toLowerCase() !== "pix"
          );
        newBrandsIntegrations.forEach((brand, index) => {
          if (brand.codePay.includes("ECOMMERCE")) {
            brand.codePay = `${brand.codePay}-${brand.brand}`;
          }

          //verifica codePay igual
          newBrandsIntegrations.forEach((otherBrand, indexOtherBrand) => {
            if (
              otherBrand.codePay.includes(brand.codePay) &&
              index !== indexOtherBrand
            ) {
              brand.codePay = `${brand.codePay}@${brand.brand}`;
            }
          });

          const minValueInstallment = brand.minimumValueInstallment
            ? parseFloat(brand.minimumValueInstallment.toString())
            : 0;
          const plans = brand.paymentPlans.filter((plan, index) => {
            return (
              totalPrice / plan.installment >= minValueInstallment ||
              index === 0
            );
          });
          brand.paymentPlans = plans;
        });
        setIntegrationBrands(newBrandsIntegrations);
        if (newBrandsIntegrations[0]) {
          setBrand(newBrandsIntegrations[0].codePay);
          setIntegrationPlans(newBrandsIntegrations[0].paymentPlans);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  }

  async function loadOrder() {
    setTotal(cartWithDiscount - ((couponDiscount?.value || 0) + (paymentDiscount?.value || 0)));
    setFreight(cartFreight);
  }

  async function getConfig() {
    setLoadingHeader(true);
    setConfig(await getAppConfig());
    setLoadingHeader(false);
    await loadOrder();
    await loadBrandsInstallments();
    setLoading(false);
  }

  const Brandlengths: Record<string, number[]> = {
    amex: [15],
    visa: [16],
    mastercard: [16],
    discover: [16],
    jcb: [16],
    "diners club": [14, 16],
    elo: [16],
    hiper: [16],
    aura: [16],
  };

  async function chooseCard() {
    if (name && number && month && year && installments && brand && cvv) {
      const numberSize = number.replace(/\D/g, "");
      const expected = Brandlengths[brand] || [];
      if (!expected.includes(numberSize.length)) {
        Swal.fire({
          icon: "warning",
          title: "Cartão incompleto",
          text: "Digite todos os números do cartão antes de continuar",
        });
        return;
      }
      const date = new Date();
      if (
        (date.getMonth() + 1 > parseInt(month) &&
          parseInt(year) === date.getFullYear()) ||
        parseInt(year) < date.getFullYear()
      ) {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Data de vencimento do cartão inválida!",
        });
        return;
      }
      setCard({
        holderName: name,
        number: number.split(" ").join("").split("_").join(""),
        expiryDate: `${month}/${year}`,
        cvv: cvv.split("_").join(""),
        cpf: "",
      });
      const integrationFind = integrationBrands.find(
        (integration) => integration.brand.toLowerCase() === brand
      );
      const planFind = integrationPlans.find(
        (integration) => integration.installment === parseInt(installments)
      );

      const resolvedCodePay = integrationFind?.codePay
        ? integrationFind.codePay
        : brand.includes("ECOMMERCE")
          ? "ECOMMERCE"
          : brand.includes("@")
            ? brand.split("@")[0]
            : brand;

      if (integrationFind) {
        setPaymentMethod({
          codePay: resolvedCodePay,
          codePlan: planFind?.codePlan ?? 0,
          nameGateway: integrationFind.nameGateway,
          nameBrand: integrationFind.brand as any,
          typePayment: payment.paymentMethod?.typePayment || "card",
          paymentItemData: integrationFind as unknown as any,
          installments: parseInt(installments),
          isAfter: payment.paymentMethod?.isAfter || false,
          method: payment.paymentMethod?.method || "cielo-card",
        });
      }

      const installmentNumber = parseInt(installments);
      if (installmentNumber > 0) {
        const totalWithFreight = total + freight;
        const installmentValue = totalWithFreight / installmentNumber;
        setSelectedInstallment({
          number: installmentNumber,
          value: installmentValue,
          total: installmentValue * installmentNumber,
          hasInterest: false,
        });
      }

      if (pluginspace?.type !== "food") {
        navigate(`/${pluginspace_id}/new-order-finalize`);
      } else {
        navigate(`/${pluginspace_id}/order-finalize`);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Verifique se preencheu todos os campos",
      });
    }
  }

  const sendLogBrand = async (cardBrand: String) => {
    try {
      api.post(
        "/api/orders/send-card-brand-unregistered",
        {
          cardBrand: detectedCodePay,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      );
    } catch (error) { }
  };

  const detectCodePayByCardNumber = (cardNumber: string): string | null => {
    const number = cardNumber.replace(/\D/g, "");

    if (Number(process.env.REACT_APP_PROD) === 0) {
      if (number === "6505050000001091") return "visa";
    }

    if (/^4/.test(number)) return "visa";
    if (/^(5[1-5]|222[1-9]|22[3-9]\d|2[3-6]\d{2}|27[01]\d|2720)/.test(number))
      return "mastercard";
    if (/^3[47]/.test(number)) return "american express";
    if (/^3(?:0[0-5]|[68])/.test(number)) return "diners club";
    if (
      /^(6011|65|64[4-9]|622(?:12[6-9]|1[3-9]\d|[2-8]\d\d|9[0-1]\d|92[0-5]))/.test(
        number
      )
    )
      return "discover";
    if (/^35/.test(number)) return "jcb";
    if (/^(606282|3841)/.test(number)) return "hiper";
    if (
      /^(4011(78|79)|431274|438935|451416|457393|504175|5067|5090|627780|636297|636368|6504|6505|6509|6516|6550)/.test(
        number
      )
    )
      return "elo";
    if (/^50/.test(number)) return "aura";

    return null;
  };

  const handleCardChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setNumber(value);

    const detectedCodePay = detectCodePayByCardNumber(value);
    setDetectedCodePay(detectedCodePay);

    setCardBrandImage(getCardBrandImage(detectedCodePay));

    const brandExists = integrationBrands.some(
      (integration) => integration.brand.toLocaleLowerCase() === detectedCodePay
    );

    if (detectedCodePay && brandExists) {
      setBrand(detectedCodePay);
      setIsButtonEnabled(true);

      const newPlans = integrationBrands.find(
        (integration) =>
          integration.brand.toLocaleLowerCase() === detectedCodePay
      );
      setIntegrationPlans(newPlans ? newPlans.paymentPlans : []);
    } else {
      setIsButtonEnabled(false);
    }
    // Ajusta máscara conforme a bandeira
    if (detectedCodePay === "amex") {
      setMaskCard("9999 999999 99999");
    } else {
      setMaskCard("9999 9999 9999 9999");
    }
  };

  return (
    <div className="payment">
      <div className="content-payment">
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className="payment-body">
            <h2>Pagamento com cartão de crédito</h2>
            <div className="form-group">
              <div className="input">
                <label>Número do cartão</label>
                <div className="card-input-container">
                  <InputMask
                    mask={maskCard}
                    type="text"
                    value={number}
                    onChange={handleCardChange}
                    onFocus={() => {
                      setMaskCard("9999 9999 9999 9999");
                      setHideMenu(true);
                    }}
                    onBlur={() => {
                      if (
                        detectedCodePay &&
                        !integrationBrands.some(
                          (i) => i.brand.toLocaleLowerCase() === detectedCodePay
                        )
                      ) {
                        toastComponent.openToast(
                          "warning",
                          `Cartões da bandeira ${detectedCodePay.charAt(0).toUpperCase() +
                          detectedCodePay.slice(1).toLowerCase()
                          } não são aceitos`,
                          3000
                        );
                        setNumber("");
                        if (!loggedBrands.includes(detectedCodePay)) {
                          setLoggedBrands((prev) => [...prev, detectedCodePay]);
                          sendLogBrand(detectedCodePay);
                        }
                      } else if (
                        !detectedCodePay &&
                        number.replace(/\D/g, "").length > 0
                      ) {
                        toastComponent.openToast(
                          "warning",
                          "A bandeira deste cartão não foi reconhecida",
                          3000
                        );
                      }
                      if (
                        number.split("_").join("").split(" ").join("").length ==
                        14
                      )
                        setMaskCard("9999 9999 9999 99");
                      else if (
                        number.split("_").join("").split(" ").join("").length ==
                        15
                      )
                        setMaskCard("9999 9999 9999 999");
                      else setMaskCard("9999 9999 9999 9999");
                      setHideMenu(false);
                      number === undefined || number[0] === "_"
                        ? setAlarmNumber(true)
                        : setAlarmNumber(false);
                    }}
                    className="card-input"
                  />
                  {cardBrandImage && (
                    <div className="card-brand-image">
                      <img src={cardBrandImage} alt="Bandeira do cartão" />
                    </div>
                  )}
                </div>
              </div>
              <div className="input">
                <label>Nome impresso no cartão</label>
                <input
                  type="text"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                  onFocus={() => setHideMenu(true)}
                  onBlur={() => {
                    setHideMenu(false);
                    name === "" ? setAlarmName(true) : setAlarmName(false);
                  }}
                />
                {alarmName && (
                  <p className="alarm-text">Informe o nome no cartão</p>
                )}
              </div>
              <div className="input-row">
                <div className="input">
                  <label>Mês de vencimento</label>
                  <select
                    value={month}
                    onChange={(event) => setMonth(event.target.value)}
                  >
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => (
                      <option value={item.toString()}>{item}</option>
                    ))}
                  </select>
                </div>
                <div className="input">
                  <label>Ano de vencimento</label>
                  <select
                    value={year}
                    onChange={(event) => setYear(event.target.value)}
                  >
                    {[
                      2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033,
                      2034,
                    ].map((item) => (
                      <option value={item.toString()}>{item}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="input-row">
                <div className="input">
                  <label>Parcela</label>
                  <select
                    value={installments}
                    onChange={(event) => setInstallments(event.target.value)}
                  >
                    {integrationPlans.map((plan) => (
                      <option value={plan.installment}>
                        {plan.installment > 1 && `${plan.installment} x `}{" "}
                        {floatToPrice((total + freight) / plan.installment)}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="input">
                  <label>Código CVV</label>
                  <InputMask
                    mask={maskCvv}
                    onBeforeInputCapture={(event) => {
                      if (
                        event.currentTarget.value.split("_").join("").length >=
                        3
                      )
                        setMaskCvv("9999");
                      else setMaskCvv("999");
                    }}
                    type="text"
                    value={cvv}
                    onChange={(event) => {
                      if (event.target.value.includes("_")) setMaskCvv("999");
                      setCvv(event.target.value);
                    }}
                    onFocus={() => setHideMenu(true)}
                    onBlur={() => {
                      setHideMenu(false);
                      cvv === undefined || cvv[0] === "_"
                        ? setAlarmCvv(true)
                        : setAlarmCvv(false);
                    }}
                  />
                  {alarmCvv && <p className="alarm-text">Informe o CVV</p>}
                </div>
              </div>
              <div className="button-payment">
                <MainButton
                  color={
                    config?.webappcolor.fontbutton
                      ? config.webappcolor.fontbutton
                      : "#636363"
                  }
                  backgroundColor={
                    config?.webappcolor.webappbutton
                      ? config.webappcolor.webappbutton
                      : "#EAEAEA"
                  }
                  text="Inserir dados do cartão"
                  onClick={chooseCard}
                  disabled={!isButtonEnabled}
                />
              </div>
            </div>
          </div>
        )}
        {!loadingHeader && (
          <Menu
            activeMenu="cart"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            hide={hideMenu}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
    </div>
  );
}
